<template>
  <div class="pdt-20px">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('echeancierFacturation.title') }}
        </p>
      </header>
      <div class="card-content">
        <div class="has-text-centered has-background-background pdt-20px pdb-20px"
             v-if="dcf.echeanciers.length === 0 || getPayeurs.length === 0">
          <h1 class="title is-size-4">
            {{ $t('echeancierFacturation.messages.noLignesVentesAndNoPayeur')}}
          </h1>
        </div>
        <div v-else>
          <div class="columns">
            <div class="column is-6">
              <div class="columns is-multiline" v-if="gestionEcheancier">
                <div class="column is-12" v-if="getPayeurs.length > 1">
                  <div v-for="(payeur, index) in getPayeurs" :key="index"
                       class="has-text-link">
                    {{ payeur.nomCommercial }} - {{ payeur.quotePart }}
                    <span v-if="payeur.typeRepartition !== constantes.MONTANT"
                          class="has-text-weight-bold">
                       : {{ getMontantRepartition(payeur) | formatDevise}}
                    </span>
                  </div>
                </div>
                <selecteur-action
                  class="column is-12"
                  @handleAction="handleAction"
                  :elementsSelectionnes="getAllLignesEcheanciersSelect.length > 0"
                  :titleButton="'general.button.apply'"
                  :options='actions'
                  :placeholder='$t("general.placeHolder.groupedAction")'
                ></selecteur-action>
              </div>
            </div>
            <div class="column is-6"
                 v-if="dcf.type === constantes.TYPE_DEVIS">
              <div class="has-text-right">
                <qd-switch :value="gestionEcheancier"
                          @input="$emit('updateGestionEcheancier', $event)">
                  <span class="has-text-default">
                    {{ $t('echeancierFacturation.actions.gestionEcheancier') }}
                  </span>
                </qd-switch>
              </div>
            </div>
          </div>
          <div v-if="gestionEcheancier" class="overflow-x-auto pdb-250px">
            <echeancier-header :allLignesSelect="allLignesSelect" @selectAll="selectAll"
                               :isNotRegie="dcf.role !== constantes.REGIE"
            >
            </echeancier-header>
            <div v-for="echeancier in getEcheanciers"
                 :key="echeancier.referenceEcheancier">
              <echeancier :echeancier="echeancier"
                          :showErrorDate="showErrorDate"
                          :dcf="dcf"
                          :lignesCommande="dcf.lignesCommande"
                          :payeurs="getPayeurs"
                          @generationEcheancierManuel="generationEcheancierManuel">
              </echeancier>
            </div>
          </div>
          <div class="has-text-centered has-background-background pdt-20px pdb-20px"
               v-else>
            <h1 class="title is-size-4">
              {{ $t('echeancierFacturation.messages.noGestionEcheancier')}}
            </h1>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpErreur"
             has-modal-card
             class="modal">
      <pop-up-erreur
        :messHeader="titleErreur"
        :messFooter="subTitleErreur"
      />
    </b-modal>
    <b-modal v-model="popUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('echeancierFacturation.messages.prevention.defusion.title')"
        :messFooter="$t('echeancierFacturation.messages.prevention.defusion.subTitle')"
        :cancel="$t('echeancierFacturation.actions.cancel')"
        :validate="$t('echeancierFacturation.actions.defusion')"
        @no="popUpPrevention  = false"
        @yes="makeDefusion"
      />
    </b-modal>
    <b-modal v-model="popUpPreventionSupp"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('echeancierFacturation.messages.prevention.suppressions.title')"
        :messFooter="$t('echeancierFacturation.messages.prevention.suppressions.subTitle')"
        :cancel="$t('echeancierFacturation.actions.cancel')"
        :validate="$t('echeancierFacturation.actions.supprimerEcheancierMasse')"
        @no="popUpPreventionSupp  = false"
        @yes="makeSuppression"
      />
    </b-modal>
    <b-modal v-model="popUpGenerationEcheancierManuel"
             has-modal-card
             class="modal">
      <pop-up-generation-echeancier-manuel
        :is-devis="dcf.type === constantes.TYPE_DEVIS"
        @updateEcheancier="updateEcheancier"
        :echeancier="echeancierAGenerer"
        :payeurs="getPayeurs"
        :montant="montant"
      />
    </b-modal>
    <b-modal v-model="popUpGenerationEcheancierManuelMasse"
             has-modal-card
             class="modal">
      <pop-up-generation-echeancier-manuel-masse
        :is-devis="dcf.type === constantes.TYPE_DEVIS"
        @updateEcheancierMasse="updateEcheancierMasse"
        :echeanciers="echeanciersMasseAGenerer"
        :payeurs="getPayeurs"
      />
    </b-modal>
    <b-modal v-model="openPopUpEditCommentaire"
             has-modal-card
             class="modal">
      <pop-up-edit-commentaire-facturation :echeancier-lignes="echeancierLignesToEdit"
                                           @updateCommentaire="updateCommentaireFacturation">
      </pop-up-edit-commentaire-facturation>
    </b-modal>
    <b-modal v-model="popUpMajDateFacture"
             has-modal-card
             class="modal">
      <pop-up-edit-date-facturation :echeancier-lignes="getAllLignesEcheanciersSelect"
                                           @updateDateFacturation="updateDateFacturation">
      </pop-up-edit-date-facturation>
    </b-modal>
  </div>
</template>

<script>

import {
  ACTION_FUSION,
  ACTION_DEFUSION,
  ACTION_EDIT_COMMENTAIRE,
  ACTION_EDIT_DATE_FACTURATION,
  ACTION_ECHEANCIER_MASSE,
  ACTION_ECHEANCIER_SUPP_MASSE,
} from '@/configuration/commande/commandeConf';
import { createNamespacedHelpers } from 'vuex';
import selecteurAction from '@/components/general/selecteurAction';
import echeancier from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancier';
import echeancierHeader from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancierHeader';
import fusionEcheancier from '@/services/commande/echeancierFacturation/fusionEcheancier';
import popUpErreur from '@/components/general/popUpErreur';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import defusionEcheancier from '@/services/commande/echeancierFacturation/defusionEcheancier';
import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import {
  INTERVENANT_REPARTITION_TYPE,
  MONTANT,
  TYPE_DEVIS,
  ANNEE,
  MOIS,
} from '@/configuration/devisConf';
import popUpGenerationEcheancierManuel from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_echeancierManuel';
import popUpGenerationEcheancierManuelMasse from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_echeancierManuelMasse';

import genererEcheancierManuel from '@/services/commande/echeancierFacturation/genererEchancierManuel';
import { REGIE } from '@/configuration/societe/societe';
import popUpEditCommentaireFacturation
  from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_commentaireFacturation';
import popUpEditDateFacturation
  from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_majDateFacturation';
import calculArrondi from '@/services/calcul/calculArrondi';
import { formatDevise } from '@/services/general/filters/formatDevise';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    dcf: {
      type: Object,
      required: true,
    },
    showErrorDate: {
      type: Boolean,
      required: true,
    },
    gestionEcheancier: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      popUpErreur: false,
      titleErreur: null,
      subTitleErreur: null,
      popUpPrevention: false,
      popUpPreventionSupp: false,
      popUpMajDateFacture: false,
      echeancierAGenerer: null,
      echeanciersMasseAGenerer: null,
      popUpGenerationEcheancierManuel: false,
      popUpGenerationEcheancierManuelMasse: false,
      montant: 0,
      openPopUpEditCommentaire: false,
      echeancierLignesToEdit: [],
      constantes: {
        TYPE_DEVIS,
        MONTANT,
        REGIE,
        ANNEE,
        MOIS,
      },
    };
  },
  components: {
    selecteurAction,
    echeancier,
    echeancierHeader,
    popUpErreur,
    popUpPrevention,
    popUpGenerationEcheancierManuel,
    popUpGenerationEcheancierManuelMasse,
    popUpEditCommentaireFacturation,
    popUpEditDateFacturation,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    actions() {
      const act = [
        { action: ACTION_DEFUSION, translation: 'echeancierFacturation.actions.defusion' },
        { action: ACTION_EDIT_COMMENTAIRE, translation: 'echeancierFacturation.actions.gestionCommentaire' },
        { action: ACTION_EDIT_DATE_FACTURATION, translation: 'echeancierFacturation.actions.majDateFacturation' },
        { action: ACTION_ECHEANCIER_MASSE, translation: 'echeancierFacturation.actions.genererEcheancierMasse' },
        { action: ACTION_ECHEANCIER_SUPP_MASSE, translation: 'echeancierFacturation.actions.supprimerEcheancierMasse' },
      ];

      return act;
    },
    getEcheanciers() {
      const lignesCommande = [];
      const echeanciers = [];
      this.dcf.echeanciers.forEach((echeancier) => {
        const lignesFind = getLignesCommandesWithReferenceEcheancier(
          this.dcf.lignesCommande, echeancier.referenceEcheancier,
        );
        lignesFind.sort((a, b) => a.ordre - b.ordre);
        if (lignesFind.length > 0) lignesCommande.push(lignesFind[0]);
        lignesCommande.sort((a, b) => a.ordre - b.ordre);
      });
      lignesCommande.forEach((ligne) => {
        echeanciers.push(
          this.dcf.echeanciers.find((echeancier) => {
            return echeancier.referenceEcheancier === ligne.referenceEcheancier;
          }),
        );
      });
      return echeanciers;
    },
    getPayeurs() {
      const payeurs = this.dcf.intervenants.filter((intervenant) => {
        return intervenant.payeur;
      });
      return payeurs.map((payeur) => {
        const repartitionTypeLibelle = this.$i18n.t(
          INTERVENANT_REPARTITION_TYPE.find((repartition) => {
            return repartition.code === payeur.typeRepartition;
          }).libelle,
        );
        return {
          nomCommercial: payeur.nomCommercial,
          quotePart: payeur.typeRepartition === MONTANT
            ? formatDevise(payeur.repartition)
            : payeur.repartition + ' ' + repartitionTypeLibelle,
          repartition: payeur.repartition,
          typeRepartition: payeur.typeRepartition,
          tiersId: payeur.tiersId,
        };
      });
    },
    getAllLignesEcheanciersSelect() {
      return this.dcf.echeanciers.filter((ligneEcheancier) => {
        return ligneEcheancier.select === true;
      });
    },
    allLignesSelect() {
      return this.getAllLignesEcheanciersSelect.length === this.dcf.echeanciers.length
        && this.dcf.echeanciers.length > 0;
    },
  },
  methods: {
    editAllCommentaires() {
      this.echeancierLignesToEdit = [];
      this.getAllLignesEcheanciersSelect.forEach((echeancier) => {
        this.echeancierLignesToEdit = this.echeancierLignesToEdit
          .concat(echeancier.echeancierLignes.filter((ligne) => {
            return !ligne.facturationFaite;
          }));
      });
      this.openPopUpEditCommentaire = true;
    },
    updateDateFacturation(dateFacturation) {
      this.popUpMajDateFacture = false;
      this.getAllLignesEcheanciersSelect
        .filter(echeancier => {
          return echeancier.quantitePeriodicite === 0
          && !echeancier.echeancierLignes.some(l => l.facturationFaite);
        })
        .forEach(echeancier => {
          echeancier.dateDebut = dateFacturation;
          echeancier.dateFin = dateFacturation;
          echeancier.dateFinPremiereEcheance = dateFacturation;
        });
      messageSucces(this.$i18n.t('echeancierFacturation.popUpDateFacturation.success')); // todo jd;x
    },
    updateCommentaireFacturation(newCommentaire) {
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.editCommentaire'));
      this.openPopUpEditCommentaire = false;
      this.getAllLignesEcheanciersSelect.forEach((echeancier) => {
        echeancier.echeancierLignes.forEach((ligne) => {
          if (!ligne.facturationFaite) ligne.commentaireFacturation = newCommentaire;
        });
      });
      this.echeancierLignesToEdit = [];
    },
    updateEcheancier(newEcheancier) {
      const indexEcheancier = this.dcf.echeanciers.findIndex((echeancier) => {
        return echeancier.referenceEcheancier === newEcheancier.referenceEcheancier;
      });
      this.dcf.echeanciers.splice(indexEcheancier, 1, newEcheancier);
      this.popUpGenerationEcheancierManuel = false;
    },
    updateEcheancierMasse(newEcheanciers) {
      for (let i = 0; i < newEcheanciers.length; i += 1) {
        const newEcheancier = newEcheanciers[i];
        const indexEcheancier = this.dcf.echeanciers.findIndex((echeancier) => {
          return echeancier.referenceEcheancier === newEcheancier.referenceEcheancier;
        });
        this.dcf.echeanciers.splice(indexEcheancier, 1, newEcheancier);
      }
      this.popUpGenerationEcheancierManuelMasse = false;
    },
    generationEcheancierManuel(referenceEcheancier, montant) {
      let echeancierFind = this.dcf.echeanciers.find((echeancier) => {
        return echeancier.referenceEcheancier === referenceEcheancier;
      });
      const lignes = getLignesCommandesWithReferenceEcheancier(
        this.dcf.lignesCommande, referenceEcheancier,
      );
      this.montant = montant;
      echeancierFind = genererEcheancierManuel(
        lignes,
        this.dcf.datePremierAffichage,
        this.dcf.dateDevisCommande,
        referenceEcheancier,
      );
      if (this.getIsTlpe(echeancierFind.referenceEcheancier)) {
        echeancierFind.unitePeriodicite = this.constantes.ANNEE;
      }
      echeancierFind.openEcheancierLignes = true;
      this.echeancierAGenerer = echeancierFind;
      this.popUpGenerationEcheancierManuel = true;
    },
    generationEcheancierManuelMasse(echeancier) {
      const lignes = getLignesCommandesWithReferenceEcheancier(
        this.dcf.lignesCommande, echeancier.referenceEcheancier,
      );
      let total = lignes.map((ligne) => { return ligne.totalHtAvecLigneRemise; })
        .reduce((montantTotal, montant) => montantTotal + montant);
      total = calculArrondi(total);
      const echeancierCalcule = genererEcheancierManuel(
        lignes,
        this.dcf.datePremierAffichage,
        this.dcf.dateDevisCommande,
        echeancier.referenceEcheancier,
      );
      echeancier.dateDebut = echeancierCalcule.dateDebut;
      echeancier.dateFin = echeancierCalcule.dateFin;
      echeancier.dateFinPremiereEcheance = echeancierCalcule.dateFinPremiereEcheance;
      if (this.getIsTlpe(echeancier.referenceEcheancier)) {
        echeancier.unitePeriodicite = this.constantes.ANNEE;
      } else echeancier.unitePeriodicite = echeancierCalcule.unitePeriodicite;
      echeancier.quantitePeriodicite = echeancierCalcule.quantitePeriodicite;
      echeancier.montant = total;
      echeancier.openEcheancierLignes = true;
    },
    getMontantRepartition(payeur) {
      if (payeur.typeRepartition === MONTANT) return payeur.repartition;
      return (payeur.repartition * this.dcf.montantHt) / 100;
    },
    selectAll() {
      const select = !this.allLignesSelect;
      this.dcf.echeanciers.forEach((ligneEcheance) => {
        ligneEcheance.select = select;
      });
    },
    makeFusion(echeanciers) {
      fusionEcheancier(
        echeanciers.map(echeancier => echeancier.referenceEcheancier), this.dcf,
      );
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.fusion'));
    },
    checkFusion() {
      const echeanciers = this.getAllLignesEcheanciersSelect;
      const haveOneEcheancierWithOneLigneWithFacturaturation = this.getAllLignesEcheanciersSelect
        .some((echeancier) => {
          return echeancier.echeancierLignes.some((ligne) => { return ligne.facturationFaite; });
        });
      const allEcheancierAreAuto = echeanciers.every((echeancier) => {
        return echeancier.quantitePeriodicite === 0;
      });
      if (!allEcheancierAreAuto || haveOneEcheancierWithOneLigneWithFacturaturation) {
        this.popUpErreur = true;
        this.titleErreur = haveOneEcheancierWithOneLigneWithFacturaturation
          ? this.$i18n.t('echeancierFacturation.messages.errors.fusionWithLigneFacture.title')
          : this.$i18n.t('echeancierFacturation.messages.errors.onlyEcheancierAuto.title');
        this.subTitleErreur = haveOneEcheancierWithOneLigneWithFacturaturation
          ? this.$i18n.t('echeancierFacturation.messages.errors.fusionWithLigneFacture.subTitle')
          : this.$i18n.t('echeancierFacturation.messages.errors.onlyEcheancierAuto.subTitle');
        return;
      }
      let lignes = [];
      echeanciers.forEach((echeancier) => {
        lignes = lignes.concat(getLignesCommandesWithReferenceEcheancier(
          this.dcf.lignesCommande, echeancier.referenceEcheancier,
        ));
      });
      const sameFournisseurAndAFacturer = lignes.every((ligne) => {
        return ligne.aFacturer === lignes[0].aFacturer
          && ligne.fournisseurId === lignes[0].fournisseurId;
      });
      if (!sameFournisseurAndAFacturer
        && this.dcf.role !== REGIE) {
        this.popUpErreur = true;
        this.titleErreur = this.$i18n.t('echeancierFacturation.messages.errors.fusionWithAFacturerFournisseurDiff.title');
        this.subTitleErreur = this.$i18n.t('echeancierFacturation.messages.errors.fusionWithAFacturerFournisseurDiff.subTitle');

        return;
      }
      this.makeFusion(echeanciers);
    },
    checkSuppression() {
      this.echeanciersMasseAGenerer = this.getAllLignesEcheanciersSelect;
      // Vérification si on n'a pas sélectionné des échéanciers possédant déjà des factures
      for (let i = 0; i < this.echeanciersMasseAGenerer.length; i += 1) {
        const echeancier = this.echeanciersMasseAGenerer[i];
        const estFacture = echeancier.echeancierLignes.some((ligne) => {
          return ligne.facturationFaite;
        });
        if (estFacture) {
          this.popUpErreur = true;
          this.titleErreur = this.$i18n.t('echeancierFacturation.messages.errors.suppressionEcheancierWithLigneFacture.title');
          this.subTitleErreur = this.$i18n.t('echeancierFacturation.messages.errors.suppressionEcheancierWithLigneFacture.subTitle');
          return;
        }
        this.popUpPreventionSupp = true;
      }
    },
    checkDefusion() {
      let error = false;
      const haveOneEcheancierWithOneLigneWithFacturaturation = this.getAllLignesEcheanciersSelect
        .some((echeancier) => {
          return echeancier.echeancierLignes.some((ligne) => { return ligne.facturationFaite; });
        });
      const referencesEcheancier = this.getAllLignesEcheanciersSelect
        .map(echeancier => echeancier.referenceEcheancier);
      referencesEcheancier.forEach((referenceEcheancier) => {
        const lignes = getLignesCommandesWithReferenceEcheancier(
          this.dcf.lignesCommande, referenceEcheancier,
        );
        if (lignes.length === 1) error = true;
      });
      if (!error && !haveOneEcheancierWithOneLigneWithFacturaturation) this.popUpPrevention = true;
      else {
        this.popUpErreur = true;
        this.titleErreur = !haveOneEcheancierWithOneLigneWithFacturaturation
          ? this.$i18n.t('echeancierFacturation.messages.errors.defusion.title')
          : this.$i18n.t('echeancierFacturation.messages.errors.defusionWithLigneFacture.title');
        this.subTitleErreur = !haveOneEcheancierWithOneLigneWithFacturaturation
          ? this.$i18n.t('echeancierFacturation.messages.errors.defusion.subTitle')
          : this.$i18n.t('echeancierFacturation.messages.errors.defusionWithLigneFacture.subTitle');
      }
    },
    makeSuppression() {
      const echeanciers = this.getAllLignesEcheanciersSelect;
      defusionEcheancier(echeanciers.map(echeancier => echeancier.referenceEcheancier), this.dcf);
      this.popUpPreventionSupp = false;
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.suppresions'));
    },
    makeDefusion() {
      const echeanciers = this.getAllLignesEcheanciersSelect;
      defusionEcheancier(echeanciers.map(echeancier => echeancier.referenceEcheancier), this.dcf);
      this.popUpPrevention = false;
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.defusion'));
    },
    handleAction(action) {
      switch (action) {
        case ACTION_DEFUSION:
          this.checkDefusion();
          break;
        case ACTION_EDIT_DATE_FACTURATION:
          this.popUpMajDateFacture = true;
          break;
        case ACTION_EDIT_COMMENTAIRE:
          this.editAllCommentaires();
          break;
        case ACTION_FUSION:
          this.checkFusion();
          break;
        case ACTION_ECHEANCIER_SUPP_MASSE:
          this.checkSuppression();

          break;
        case ACTION_ECHEANCIER_MASSE:
          this.echeanciersMasseAGenerer = this.getAllLignesEcheanciersSelect;
          // Vérification si on n'a pas sélectionné des échéanciers possédant déjà des factures
          for (let i = 0; i < this.echeanciersMasseAGenerer.length; i += 1) {
            const echeancier = this.echeanciersMasseAGenerer[i];
            const estFacture = echeancier.echeancierLignes.some((ligne) => {
              return ligne.facturationFaite;
            });
            if (estFacture) {
              this.popUpErreur = true;
              this.titleErreur = this.$i18n.t('echeancierFacturation.messages.errors.generationEcheancierWithLigneFacture.title');
              this.subTitleErreur = this.$i18n.t('echeancierFacturation.messages.errors.generationEcheancierWithLigneFacture.subTitle');
              return;
            }
          }
          // Préparation des échéanciers
          for (let i = 0; i < this.echeanciersMasseAGenerer.length; i += 1) {
            this.generationEcheancierManuelMasse(this.echeanciersMasseAGenerer[i]);
          }
          if (this.echeanciersMasseAGenerer.some(ech => {
            return ech.unitePeriodicite !== this.constantes.ANNEE;
          })) {
            this.echeanciersMasseAGenerer.filter(
              echeancier => echeancier.unitePeriodicite === this.constantes.ANNEE,
            )?.map(echeancier => {
              echeancier.unitePeriodicite = this.constantes.MOIS;
              return echeancier;
            });
          }
          this.popUpGenerationEcheancierManuelMasse = true;
          break;
        default:
          break;
      }
    },
    getIsTlpe(referenceEcheancier) {
      if (this.dcf.lignesCommande.length === 0) return false;
      return this.dcf.lignesCommande.some((ligne) => {
        return ((ligne.lignesCommande?.length > 0 && ligne.lignesCommande.some(ligneEnfant => {
          return ligneEnfant.referenceEcheancier === referenceEcheancier
          && ligneEnfant.produit?.produitDivers?.tlpe;
        })) || (ligne.referenceEcheancier === referenceEcheancier
        && ligne.produit?.produitDivers?.tlpe));
      });
    },
  },
};
</script>
